'use client';

import { FC, PropsWithChildren, Suspense, useEffect } from 'react';
import { useStore } from '@/store/zustand/zustand.setup';
import { cn } from '@/utils';
import FeatureFlag from '../feature-flag/feature-flag';
import AgeVerificationModal from './age-verification-modal/age-verification-modal';
import CookieConsent from './cookie-consent/cookie-consent';
import DefaultFooter from './footer/default-footer';
import HeaderChrome from './header-chrome/header-chrome';

type Props = PropsWithChildren<{
  isLanding?: boolean;
  smallPadding?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
}>;

const Layout: FC<Props> = ({
  isLanding = false,
  children,
  smallPadding: disablePadding = false,
  showHeader = true,
  showFooter = true,
}) => {
  const { checkAgeVerification } = useStore();

  useEffect(() => {
    checkAgeVerification();
  }, [checkAgeVerification]);

  return (
    <>
      <FeatureFlag feature="ageVerification">
        <AgeVerificationModal />
      </FeatureFlag>
      <div className="flex min-h-screen flex-col">
        {showHeader ? <HeaderChrome /> : null}
        <main className={cn('bg-background flex-1', !isLanding && 'py-6')}>
          <div
            className={cn(
              !isLanding && 'container mx-auto px-5 sm:px-6 md:px-8',
              disablePadding && 'md:px-5',
            )}
          >
            {/*
              Suspense boundary required by Next 15 for any descendant client
              component that calls `useSearchParams()` — without it, those
              components fail static prerender (`missing-suspense-with-csr-bailout`).
              Pages that don't suspend (e.g. the landing page) prerender normally;
              only pages whose children read search params bail to the fallback
              and hydrate on the client.
            */}
            <Suspense fallback={null}>{children}</Suspense>
          </div>
        </main>
        <CookieConsent />
        {showFooter ? <DefaultFooter /> : null}
      </div>
    </>
  );
};

export default Layout;
